export const GAME_TAG = {
  CS: "CS",
  VALORANT: "Valorant",
};

export const GAME_CSS = {
  CS: "cs",
  VALORANT: "valorant",
};
